export default class UnusualError extends Error {
    constructor () {
        super();
    }
}

